// extracted by mini-css-extract-plugin
module.exports = {"Services":"Services_Services__22Xi-","select":"Services_select__2ZmME"};